module.exports = __webpack_public_path__ + "img/books_walkthrough_2.b0723aee.png";